const pickImageUrl = (value) => {
  if (value == null) return null;

  if (typeof value === "string") {
    const t = value.trim();

    return t || null;
  }

  return null;
};

const getResponseUserImageUrl = (responseGroup, userInfo, isAnonymous) => {
  if (isAnonymous) return null;
  const u =
    userInfo && typeof userInfo === "object" && !Array.isArray(userInfo)
      ? userInfo
      : null;
  const g =
    responseGroup &&
    typeof responseGroup === "object" &&
    !Array.isArray(responseGroup)
      ? responseGroup
      : {};
  const nestedUser =
    g.user && typeof g.user === "object" && !Array.isArray(g.user)
      ? g.user
      : null;

  return (
    pickImageUrl(u?.image) ||
    pickImageUrl(u?.avatar) ||
    pickImageUrl(u?.profile_image) ||
    pickImageUrl(u?.photo_url) ||
    pickImageUrl(u?.picture) ||
    pickImageUrl(u?.profile?.image) ||
    pickImageUrl(nestedUser?.image) ||
    pickImageUrl(nestedUser?.avatar) ||
    pickImageUrl(nestedUser?.profile?.image) ||
    pickImageUrl(g.user_image) ||
    pickImageUrl(g.userAvatar) ||
    null
  );
};

const isRecordVideoAnswer = (entry) =>
  entry &&
  typeof entry === "object" &&
  (entry.type === "record-video" || entry.input_type === "record-video") &&
  typeof entry.value === "string" &&
  entry.value.trim().length > 0;

const detailsContainVideo = (details = []) =>
  details.some((detail) => {
    if (!detail?.response) return false;

    try {
      const parsed = JSON.parse(detail.response);
      const responses = parsed?.responses;

      if (!responses || typeof responses !== "object") {
        return false;
      }

      return Object.values(responses).some(isRecordVideoAnswer);
    } catch {
      return false;
    }
  });

const getResponseUserEmail = (details = [], userInfo = {}) => {
  const directEmail = userInfo?.email;

  if (directEmail && String(directEmail).trim()) {
    return String(directEmail).trim();
  }

  for (const detail of details) {
    if (!detail?.response) continue;

    try {
      const parsedResponse =
        typeof detail.response === "string"
          ? JSON.parse(detail.response)
          : detail.response;
      const responses = parsedResponse?.responses;

      if (!responses || typeof responses !== "object") {
        continue;
      }

      for (const [, response] of Object.entries(responses)) {
        const value = response?.value;

        if (
          response?.type === "email" &&
          value &&
          typeof value !== "object" &&
          String(value).trim()
        ) {
          return String(value).trim();
        }
      }
    } catch (e) {
      console.warn("Failed to parse response email:", e);
    }
  }

  return null;
};

const getResponseUserName = (details = [], userInfo = {}) => {
  const directName = userInfo?.full_name || userInfo?.fullName || userInfo?.name;

  if (directName && String(directName).trim()) {
    return String(directName).trim();
  }

  for (const detail of details) {
    if (!detail?.response) continue;

    try {
      const parsedResponse =
        typeof detail.response === "string"
          ? JSON.parse(detail.response)
          : detail.response;
      const responses = parsedResponse?.responses;

      if (!responses || typeof responses !== "object") {
        continue;
      }

      for (const [, response] of Object.entries(responses)) {
        const value = response?.value;

        if (
          response?.type === "name" &&
          value &&
          typeof value !== "object" &&
          String(value).trim()
        ) {
          return String(value).trim();
        }
      }
    } catch (e) {
      console.warn("Failed to parse response name:", e);
    }
  }

  return null;
};

export const formatResponseData = (responses) => {
  if (!responses?.length) return [];
  return responses.map((responseGroup) => {
    try {
      const userInfo = responseGroup._id;
      const details = responseGroup.details;
      const userId = userInfo?._id;
      const hasVideo = detailsContainVideo(details);

      const latestResponse = details[details.length - 1];
      const totalQuestions = latestResponse.total_questions;
      const currentStep = latestResponse.step;

      let isAnonymous = false;

      if (details[0]?.response) {
        try {
          const firstResponseData = JSON.parse(details[0].response);
          isAnonymous = firstResponseData.anonymous || false;
        } catch (e) {
          console.warn("Failed to parse first response:", e);
        }
      }

      const tempStep = Number(currentStep + 1);
      const completionPercentage = (
        (tempStep / totalQuestions) * 100
      ).toFixed(1);

      const userImage = getResponseUserImageUrl(
        responseGroup,
        userInfo,
        isAnonymous,
      );
      const userEmail = getResponseUserEmail(details, userInfo);
      const userName = getResponseUserName(details, userInfo);

      return {
        key: userId ?? `fallback-${responseGroup._id?._id ?? "unknown"}`,
        userId: userId || null,
        hasVideo,
        srNo: details[0]?.step || 1,
        // Prefer real contact answers over anonymous display placeholders
        name: userName,
        email: userEmail,
        questions: `${tempStep}/${totalQuestions}`,
        responses: details.length.toString(),
        percentage: `${completionPercentage}%`,
        anonymous: isAnonymous ? "Yes" : "No",
        status: tempStep === totalQuestions ? "Completed" : "Incomplete",
        avatar: userImage || undefined,
        details: details,
        total_questions: totalQuestions,
      };
    } catch (error) {
      console.warn("Error processing response:", error);
      return {
        key: `fallback-${responseGroup._id?._id}`,
        userId: null,
        hasVideo: false,
        srNo: 1,
        name: null,
        email: null,
        questions: "0/0",
        responses: "0",
        percentage: "0%",
        anonymous: "No",
        status: "Incomplete",
        avatar: undefined,
        details: [],
      };
    }
  });
};
